import { initSlider } from './common';

export default function initFeaturedTopicsBlock2() {
    const blocks = [].slice.call(document.querySelectorAll('.ftdtopics2'));
    blocks.forEach(initBlock);
}

/**
 * @param {HTMLElement} root
 */
function initBlock(root) {
    const swiperContainerEl = root.querySelector('.swiper-container');

    const topicEls = [].slice.apply(root.querySelectorAll('.ftdtopics2-topic'));

    topicEls.forEach((el, idx) => {
        const wrapperEl = el.querySelector('.ftdtopics2-topicTextWrapper');
        if (!wrapperEl) {
            return;
        }
        const contentEl = el.querySelector('.ftdtopics2-topicContent');
        const readMoreBtn = wrapperEl.querySelector('.readMoreBtn');
        const textEl = wrapperEl.querySelector('.ftdtopics2-topicText');
        if (textEl.innerText.length > 120) {
            wrapperEl.classList.add('is--minimized');
            readMoreBtn.classList.add('is--visible');
        }
        readMoreBtn.addEventListener('click', () => {
            showSimplestModal(contentEl.innerHTML);
        });
    });

    initSlider(swiperContainerEl, {
        spaceBetween: 16,
    });

    function showSimplestModal(html) {
        const [modalEl, innerEl, contentEl, closeBtn] = [
            'div',
            'div',
            'div',
            'button',
        ].map(tag => document.createElement(tag));

        closeBtn.innerHTML = '<span class="icon icon-close"></span>';
        modalEl.classList.add('stm');
        innerEl.classList.add('stm-inner');
        closeBtn.classList.add('stm-closeBtn');
        contentEl.classList.add('stm-content');

        contentEl.innerHTML = html;

        closeBtn.addEventListener('click', close);
        modalEl.addEventListener('click', event => {
            if (event.target === modalEl) {
                close();
            }
        });

        open();

        function open() {
            innerEl.appendChild(closeBtn);
            innerEl.appendChild(contentEl);
            modalEl.appendChild(innerEl);
            document.body.appendChild(modalEl);

            setTimeout(() => {
                modalEl.classList.add('is--open');
            }, 10);
        }

        function close() {
            modalEl.classList.remove('is--open');
            setTimeout(() => {
                modalEl.parentElement.removeChild(modalEl);
            }, 1000);
        }
    }
}
